import { Identifier } from "../../core";
export class PromotionTypeId extends Identifier {
    constructor(id) {
        super("PromotionTypeId", id);
    }
}
